import {
  GETTING_TEMPLATES_FAILED,
  GETTING_TEMPLATE_FAILED,
  CREATING_TEMPLATE_FAILED,
  UPDATING_TEMPLATE_FAILED,
  DELETING_TEMPLATES_FAILED,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE_FAILED
} from 'store/template/actions';

import { goToButton, dismissButton } from '../../helpers/error/buttonBuilders';
import { TEMPLATE, TEMPLATES } from '../UserMessaging/userMessageDomains';

const templates = {
  [TEMPLATES]: {
    [GETTING_TEMPLATES_FAILED]: {
      userMessage: {
        instructions: 'Failed getting all templates',
        buttons: [dismissButton()]
      }
    },

    [GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE_FAILED]: {
      userMessage: {
        instructions: 'Failed to archive template',
        buttons: [dismissButton()]
      }
    }
  }
};

const template = {
  [TEMPLATE]: {
    [GETTING_TEMPLATE_FAILED]: {
      resource: 'template',
      userMessage: {
        buttons: [goToButton('OK', '/templates')]
      }
    },

    [GETTING_ASSOCIATED_CAMPAIGNS_FOR_TEMPLATE_FAILED]: {
      resource: 'template',
      userMessage: {
        instructions: 'Failed to archive template',
        buttons: [dismissButton()]
      }
    },

    [UPDATING_TEMPLATE_FAILED]: {
      resource: 'template',
      userMessage: {
        instructions: 'Could not save template, please try again',
        buttons: [dismissButton()]
      }
    },

    [DELETING_TEMPLATES_FAILED]: {
      resource: 'template',
      userMessage: {
        instructions: 'Could not delete template, please try again',
        buttons: [dismissButton()]
      }
    },

    [CREATING_TEMPLATE_FAILED]: {
      resource: 'template',
      userMessage: {
        instructions: 'Could not save template, please try again',
        buttons: [dismissButton()]
      }
    }
  }
};

export default { ...templates, ...template };
